import { render, staticRenderFns } from "./Stepper3.vue?vue&type=template&id=04886d14&scoped=true&"
var script = {}
import style0 from "./Stepper3.vue?vue&type=style&index=0&id=04886d14&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04886d14",
  null
  
)

export default component.exports